import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import AboutUs from '@/components/AboutUs/AboutUs'
import CallUs from '@/components/CallUs/CallUs'
import Map from '@/components/CallUs/Map'
import Job from '@/components/CallUs/Job'
import Index from '@/components/Index'
import Product from '@/components/Product/Product'
import ProductI from '@/components/Product/ProductI'
import ProductII from '@/components/Product/ProductII'
import Technical from '@/components/Technical'
import News from '@/components/News/News'
import NewsDetail from '@/components/News/NewsDetail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/dist/',
  routes: [
    {
      path: '/', name: 'HydraBase', component: Index,
      children: [
        { path: '/', component: Home, name: '首页' ,meta:{title:'海德贝思液压 | 高性能螺纹插装阀',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves'} },
        { path: '/AboutUs', component: AboutUs, name: '公司简介',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 公司简介',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | About'} },
        {
          path: '/CallUs', component: CallUs, name: '联系我们',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 联系我们',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | Contact'}
          // , children: [
          //   { path: '/CallUs/Map', component: Home, name: '联系方式' },
          //   { path: '/CallUs/Job', component: Home, name: '招聘信息' },
          // ]
        },
        { path: '/Product', component: Product, name: '产品中心',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 产品中心',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | Products'} },
        { path: '/ProductDetail', component: ProductI, name: '产品中心',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 产品中心',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | Products'} },
        { path: '/ProductIntroduce', component: ProductII, name: '产品中心' ,meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 产品中心',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | Products'}},     
        { path: '/Technical', component: Technical, name: '技术支持',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 技术支持',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | Support'} },  
        { path: '/News', component: News, name: '新闻动态',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 新闻动态',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | News'} },  
        { path: '/NewsDetail', component: NewsDetail, name: '新闻详情',meta:{title:'海德贝思液压 | 高性能螺纹插装阀 | 新闻动态',titleEn:'HydraBase China | High Performance Hydraulic Cartridge Valves | News'} },  
        
      ]
    },
  ],
  scrollBehavior(to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js